import { Model } from 'pinia-orm'

import { Attr, BelongsTo, Bool, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { QrCode } from 'modules/QrCode/QrCode'
import { Equipment } from 'modules/Equipment/Equipment'
import { Fluid } from 'modules/Fluid/Fluid'
import { Transaction } from 'modules/Transaction/Transaction'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class Compartment extends Model {
  static override entity = 'compartments'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare equipment_id: string | null
  @Attr(null) declare compartment_number: number | null
  @Attr(null) declare fluid_id: string | null
  @Attr(null) declare volume: number | null
  @Attr(null) declare fluid_uom: string | null
  @Bool(false) declare preset: boolean
  @Attr(null) declare preset_volume: number | null
  @Bool(true) declare active: boolean
  @Attr(null) declare qr_code: string | null
  @Attr(null) declare source: string | null
  @Attr(null) declare created_by: string | null
  @Attr(null) declare qr_code_added_datetime: string | null
  @Attr(null) declare qr_author: string | null
  @Bool(true) declare qr_in_use: boolean
  @Bool(false) declare qr_only: boolean
  @Bool(false) declare odo_required: boolean

  @BelongsTo(() => Equipment, 'equipment_id') declare equipment: Equipment | null
  @BelongsTo(() => Fluid, 'fluid_id') declare fluid: Fluid | null

  @HasMany(() => QrCode, 'compartment_id') declare qr_codes: QrCode[]
  @HasMany(() => Transaction, 'compartment_id') declare transactions: Transaction[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
